// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"iconButton_171n2","menu":"menu_2vn49","menuItem":"menuItem_bysj3","labelText":"labelText_615s5"};